
  
<div class="suggested-points__container">
  <header #suggestedPointsHeader class="suggested-points__header">
    <h2 class="suggested-points__title ci-heading-h6-semibold"> 
      {{ dataAddNewPointOrReplacePoint.title | translate }} 
    </h2>
    
    @if(availableInterestList?.length > 0){
      <interest-filter 
        (interestsIdsChange)="handleInterestsIdsChange($event)" 
        [interestList]="availableInterestList"
      />
    }
    <app-search-engine (searchTermChange)="handleSearchTermChange($event)" />
  </header>
  
  <main class="suggested-points__main">
    <div #suggestedViewport class="suggested-points__viewport">
      @if (filteredSuggestedPoints.length === 0) {
      
        <p class="suggested-points__no-results ci-subheading-semibold">
          {{ noResultsFoundMessage | translate }}
        </p>
        
      } @else {
          <ul class="suggested-points__list">
            <li *uiScroll="let point of datasource; let index = index">
                <div class="item-pad" [class.is-last]="index === filteredSuggestedPoints?.length - 1">
                  <app-card [indexCard]="index" [point]="point"></app-card>
                </div>
            </li>
          </ul>
        }
    </div>
  </main>
</div>

<app-drag-handle />